import TrailerControls from './TrailerControls';

export default TrailerControls;
